<template>
    <div>
        <el-card >
            
           <el-input placeholder="请输入关键字" v-model="searchName" style="width:300px" class="input-with-select">
                <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
            </el-input>
             <el-button   type="primary" style="margin-left:15px" @click="addShow()">新增</el-button>
        </el-card>

        <el-card style=" margin-top: 15px;">
            <el-table
             :data='list'
             row-key="id"
            >
                 <el-table-column
                    prop="id"
                    label="编号"
                    sortable
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="crisisName"
                    label="危机程度"
                    sortable
                 >
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    label="日期"
                    sortable
                 >
                </el-table-column>
                <el-table-column
                prop="updateTime"
                label="修改时间">
                </el-table-column>
                 <el-table-column
                    label="操作">
                    <template  slot-scope="scope">
                       
                        <el-button size='mini' @click="updShow(scope.row)">修改</el-button>
                        <el-button size='mini' type="danger" @click="del(scope.row)" >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog 
            :visible.sync="dialogVisible" 
            width="380px"
            @close="closeDialog()"
            :title="currentData!=undefined && currentData.id>0 ? '修改':'新增'"
            >
                <el-form :model="currentData"   ref="currentAddData" label-width="100px">
                    <el-form-item 
                     label="危机程度"
                    >
                       <el-input v-model="currentData.crisisName"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('currentAddData')">保存</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </el-card>
    </div>
</template>

 <script>
 
 
 export default {
    name: 'Crisis',
    props:[],
    data(){
       return {
         list:[],
         currentData:{},
         dialogVisible:false,
         searchName:''
       }
    },
    created:function() {
        this.getList();
    },
    methods:{
        getList(){
            let vm = this;
            this.axios.get('/CrisisEnum').then(function({data}) {
                vm.list=data.data;
            })
        },
        addShow(){
            this.dialogVisible=true;
        },
        updShow(obj){
            this.currentData={...obj};
            this.dialogVisible=true;
        },
        closeDialog(){
            this.currentData={};
            this.dialogVisible=false;
        },
        submitForm(formName){
            let vm = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                   if(this.currentData.crisisName==undefined || this.currentData.crisisName==''){
                        this.$message.error('请填写危机程度');
                        return;
                   }
                  let obj = {...this.currentData};
                  if(this.currentData.id!=undefined && this.currentData.id>0){
                          this.axios.post('/CrisisEnum/upd',this.currentData).then(function({data}){
                                if(data.result){
                                    vm.getList();
                                    vm.currentData={};
                                    vm.$message.success(data.message);
                                    vm.dialogVisible=false;
                                }else{
                                    vm.$message.error(data.message);
                                }
                            })
                
                  }else{
                     this.axios.post('/CrisisEnum',this.currentData).then(function({data}){
                        if(data.result){
                            vm.getList();
                            vm.currentData={};
                            vm.$message.success(data.message);
                            vm.dialogVisible=false;

                        }else{
                           vm.$message.error(data.message);
                        }
                    })
                  }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
          this.$refs[formName].resetFields();
          this.currentAddData={};
        },
        del(obj){
            let vm = this;
            this.axios.get(`/CrisisEnum/Del/${obj.id}`).then(function({data}){
                        if(data.result){
                            vm.getList();
                            
                            vm.$message.success(data.message);

                        }else{
                           vm.$message.error(data.message);
                        }
                    })
           },
           onSearch(){
                if(this.searchName!=''){
                   this.list=  this.list.filter(d=>d.crisisName.indexOf(this.searchName)>-1);
               }else{
                    this.getList();
               }
           }
    }
 }
 </script>
 


// WEBPACK FOOTER //
// src/components/manage/setting/Crisis.vue